export default "__VITE_ASSET__DAJqaoYg__"